import {
  AllProductsIcon,
  ExtractIcon,
  Flex,
  FlowerIcon,
  GearIcon,
  GrowIcon,
  GummyIcon,
  JaneGoldIcon,
  MerchIcon,
  PrerollIcon,
  StarFilledIcon,
  TagFilledIcon,
  TinctureIcon,
  TopicalIcon,
  VapeIcon,
} from '@iheartjane/reefer';
import type { IconColor } from '@iheartjane/reefer';
import { hex } from 'wcag-contrast';

import { useRootLoaderData } from '@jane/bloom/hooks/useRootLoaderData';

const GRAYS_ULTRALIGHT = '#F7F7F7';
const GRAYS_BLACK = '#000000';
const CATEGORY_ICONS = {
  brand_specials: JaneGoldIcon,
  deals: TagFilledIcon,
  edible: GummyIcon,
  extract: ExtractIcon,
  featured: StarFilledIcon,
  flower: FlowerIcon,
  gear: GearIcon,
  grow: GrowIcon,
  merch: MerchIcon,
  ['pre-roll']: PrerollIcon,
  ['shop-all']: AllProductsIcon,
  tincture: TinctureIcon,
  topical: TopicalIcon,
  vape: VapeIcon,
};

interface CategoryIconProps {
  category: string;
  selected?: boolean;
}

export function CategoryIcon({
  category,
  selected = false,
}: CategoryIconProps) {
  const { theme } = useRootLoaderData();
  const primaryColor = theme?.bloom?.colors?.primary?.main ?? GRAYS_BLACK;
  const darkPrimaryColor = hex(primaryColor, GRAYS_ULTRALIGHT) >= 3;

  const CategoryIcon = CATEGORY_ICONS[category as keyof typeof CATEGORY_ICONS];

  let iconColor = 'inherit';
  if (selected) {
    if (category === 'brand_specials') {
      iconColor = 'gold';
    } else {
      iconColor = darkPrimaryColor ? 'grays-ultralight' : 'primary';
    }
  }

  /**
   * Non selected icons:
   * - Always "inherit" / black icon color with no background
   *
   * Selected icons:
   * - If primary color is dark enough, use primary as the background with
   *   grays-ultralight as the icon color
   * - If primary color is light, use black as the background and primary
   *   as the icon color
   */

  return (
    <Flex
      {...(selected && {
        alignItems: 'center',
        background: darkPrimaryColor ? 'primary' : 'grays-black',
        borderRadius: 'xl',
        height: 40,
        justifyContent: 'center',
        width: 40,
      })}
    >
      <CategoryIcon color={iconColor as IconColor} contrastCompliant />
    </Flex>
  );
}
